module.exports = __webpack_public_path__ + "static/media/talasha.e222ec5a.png";